import { UNKNOWN } from "@/data/factFind";

const inputClass =
  "w-full bg-transparent border-b border-black/20 focus:border-[#0A2333] outline-none py-2.5 text-base md:text-sm text-[#111413] placeholder:text-[#8A8F8B] transition-[border-color] duration-300 disabled:text-[#A78558] disabled:italic";

const Control = ({ field, id, value, onChange, disabled }) => {
  const common = { id, "data-testid": `ff-${id}`, disabled, className: inputClass };
  if (disabled) return <input {...common} value={UNKNOWN} readOnly />;
  if (field.type === "select") {
    return (
      <select {...common} value={value} onChange={(e) => onChange(e.target.value)} className={`${inputClass} cursor-pointer`}>
        <option value="">—</option>
        {field.options.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    );
  }
  if (field.type === "textarea") {
    return <textarea {...common} rows={3} maxLength={2000} value={value} onChange={(e) => onChange(e.target.value)} className={`${inputClass} resize-none`} />;
  }
  const type = { money: "text", number: "text", date: "date", email: "email", tel: "tel" }[field.type] || "text";
  const inputMode = field.type === "money" || field.type === "number" ? "decimal" : undefined;
  return (
    <input
      {...common}
      type={type}
      inputMode={inputMode}
      maxLength={300}
      placeholder={field.type === "money" ? "$" : ""}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export const FactField = ({ field, id, label, value = "", onChange }) => {
  const unknown = value === UNKNOWN;
  return (
    <div className="min-w-0">
      <div className="flex items-center justify-between gap-3">
        <label htmlFor={id} className="text-[11px] uppercase tracking-[0.14em] text-[#4A524D] leading-snug">
          {label}
        </label>
        <button
          type="button"
          data-testid={`ff-${id}-unknown`}
          aria-pressed={unknown}
          onClick={() => onChange(unknown ? "" : UNKNOWN)}
          className={`shrink-0 rounded-full border px-2.5 py-1 text-[10px] uppercase tracking-[0.12em] transition-colors duration-200 ${
            unknown ? "border-[#A78558] bg-[#A78558] text-white" : "border-black/15 text-[#8A8F8B] hover:border-[#A78558] hover:text-[#A78558]"
          }`}
        >
          Unknown
        </button>
      </div>
      <Control field={field} id={id} value={value} onChange={onChange} disabled={unknown} />
    </div>
  );
};
